export default __webpack_public_path__ + "static/media/icon-check-green.6ca73283.jpg";